import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=6c0757ea&"
import script from "./Approvals.vue?vue&type=script&lang=ts&"
export * from "./Approvals.vue?vue&type=script&lang=ts&"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=6c0757ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports